import React from 'react';
import { times } from 'lodash-es';

import Skeleton from '../../../Skeleton';

export default {
  detailsStoreSwitcher: (
    <div className="app-quick-view__details-switcher">
      <Skeleton height={32} width={64} />
    </div>
  ),
  detailsDescription: (
    <div className="insights-details-block">
      <div className="insights-details-block__content">
        {times(2).map((n) => (
          <Skeleton key={n} height={16} />
        ))}
        <Skeleton height={16} width={70} />
      </div>
    </div>
  ),
  detailsSlider: (
    <div className="insights-details-block">
      <h4 className="insights-details-block__head h4">
        <Skeleton height={24} width={200} />
      </h4>
      <div className="insights-details-block__content d-flex justify-content-between">
        {times(3).map((n) => (
          <Skeleton key={n} height={322} width={149} borderRadius={12} />
        ))}
      </div>
    </div>
  ),
  detailsTable: (
    <div className="insights-details-block">
      <h4 className="insights-details-block__head h4">
        <Skeleton height={24} width={200} />
      </h4>
      <div className="insights-details-block__content">
        {times(5).map((n) => (
          <Skeleton key={n} height={24} />
        ))}
      </div>
    </div>
  ),
};
